import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const DashboardListAction = createAsyncThunk(
  "dashboard/list",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const RegistrationGraphAction = createAsyncThunk(
  "dashboard/registration",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const url = `/auth/data-visualization?${query}`;
      const response = await Api.get(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);




export const dashboardTopSavedAction = createAsyncThunk(
  "dashboard/topSaved",
  async (reqBody, thunkAPI) => {
    try {
      const { startOfWeek, endOfWeek, schoolId } = reqBody;
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard/save-videos?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);



export const dashboardTopVideosAction = createAsyncThunk(
  "dashboard/topVideos",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard/videos?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const dashboardTopCategoryAction = createAsyncThunk(
  "dashboard/topCategory",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard/categories?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const dashboardTopTagsAction = createAsyncThunk(
  "dashboard/topTags",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard/tags?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const dashboardTopActivityAction = createAsyncThunk(
  "dashboard/topActivity",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/dashboard/group-activity?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const dashboardSupportQueries = createAsyncThunk(
  "dashboard/supportQueries",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/auth/supportQueries?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
